<template>
  <div>
    <DxTabPanel
      :element-attr="tabPanelAttributes"
      :data-source="transferSteps"
      :loop="false"
      :selected-item="currentItem"
      :selected-index="currentStep"
      :animation-enabled="true"
      :swipe-enabled="false"
      :show-nav-buttons="false"
      @selection-changed="tabSelectionChanged($event)"
    >
      <template #item="{ data: step }">
        <div>
          <DxScrollView ref="transferInputScroll" v-show="step == 1" class="transfer-input-scroll" :use-native="true">
            <div class="transfer_input_holder" :class="[{ input_holder_error: $v.transferData.transfer_date.$error }]">
              <div @click="showCalendarSelector">
                <div class="input_label">{{ $t("common.date") }}</div>
                <div class="input_value">
                  {{ transferData.transfer_date }}
                </div>
              </div>
              <div v-if="is_date_selector_visible">
                <FunctionalCalendar
                  :date-format="getDefaultDateFormat.toLowerCase()"
                  :is-date-range="false"
                  v-model="calendarData"
                  :change-month-function="true"
                  :change-year-function="true"
                  :is-date-picker="true"
                  @choseDay="calendarDayChosen"
                  @input="onDateSelected"
                ></FunctionalCalendar>
              </div>
            </div>
            <div class="transfer_input_holder" :class="[{ input_holder_error: $v.transferData.warehouse_uuid.$error }]">
              <div class="input_label">{{ $t("stock_mobile.form.sender_warehouse") }}</div>
              <div class="input_value">
                <DxSelectBox
                  v-model="transferData.warehouse_uuid"
                  :search-enabled="true"
                  search-mode="contains"
                  search-expr="name"
                  class="input_value dx_input_value"
                  :placeholder="$t('stock_mobile.form.select_sender_warehouse')"
                  :data-source="warehouses"
                  :display-expr="warehouseDisplayExpr"
                  value-expr="uuid"
                  :show-clear-button="false"
                  drop-down-button-template="imageIcon"
                  @selection-changed="warehouseChanged"
                >
                  <template #imageIcon>
                    <div>
                      <div class="dx_combo_open_button" v-show="!transferData.warehouse_uuid || transferData.warehouse_uuid == ''">
                        <img src="@/assets/images/icons/plus_green.svg" class="custom-selector-icon" />
                      </div>
                      <div class="dx_combo_open_button" v-show="transferData.warehouse_uuid && transferData.warehouse_uuid.length > 0">
                        <img src="@/assets/images/icons/edit.svg" class="custom-selector-icon" />
                      </div>
                    </div>
                  </template>
                  <template #item="{ data }">
                    <div class="dx_custom_combo_item">{{ data.name }} - {{ data.department?.name ?? "-" }}</div>
                  </template>
                </DxSelectBox>
              </div>
            </div>
            <div class="transfer_input_holder" :class="[{ input_holder_error: $v.transferData.dest_warehouse_uuid.$error }]">
              <div class="input_label">{{ $t("stock_mobile.form.receiver_warehouse") }}</div>
              <div class="input_value">
                <DxSelectBox
                  v-model="transferData.dest_warehouse_uuid"
                  :search-enabled="true"
                  search-mode="contains"
                  search-expr="name"
                  class="input_value dx_input_value"
                  :placeholder="$t('stock_mobile.form.select_receiver_warehouse')"
                  :data-source="destWarehouses.filter((w) => !w.is_source)"
                  :display-expr="warehouseDisplayExpr"
                  value-expr="uuid"
                  :show-clear-button="false"
                  drop-down-button-template="imageIcon"
                >
                  <template #imageIcon>
                    <div>
                      <div
                        class="dx_combo_open_button"
                        v-show="!transferData.dest_warehouse_uuid || transferData.dest_warehouse_uuid == ''"
                      >
                        <img src="@/assets/images/icons/plus_green.svg" class="custom-selector-icon" />
                      </div>
                      <div
                        class="dx_combo_open_button"
                        v-show="transferData.dest_warehouse_uuid && transferData.dest_warehouse_uuid.length > 0"
                      >
                        <img src="@/assets/images/icons/edit.svg" class="custom-selector-icon" />
                      </div>
                    </div>
                  </template>
                  <template #item="{ data }">
                    <div class="dx_custom_combo_item">{{ data.name }} - {{ data.department?.name ?? "-" }}</div>
                  </template>
                </DxSelectBox>
              </div>
            </div>
            <div class="transfer_input_holder" @click="ordersClick">
              <div class="transfer_parcel_select_edit">
                <div class="transfer_parcel_info">
                  <div class="input_label">{{ $t("stock_management.orders.title") }}</div>
                  <div v-if="selectedOrders.length > 0" class="input_value">{{ getSelectedOrders() }}</div>
                  <div v-else class="input_value_placeholder" style="color: #989696 !important">{{ $t("stock_mobile.form.select_orders") }}</div>
                  <div class="transfer_input_second_value">
                    {{ selectedOrders.length > 2 ? $t("stock_mobile.form.more_orders_count", { count: selectedOrders.length - 2 }) : "" }}
                  </div>
                </div>
                <div class="transfer_parcel_edit_icon" @click="ordersClick()">
                  <i class="fa-regular fa-edit"></i>
                </div>
              </div>
            </div>
            <div
              class="transfer_input_holder"
              @click="showProductSelector"
              :class="[{ input_holder_error: $v.transferData.products.$error }]"
            >
              <div class="transfer_parcel_select_edit">
                <div class="transfer_parcel_info">
                  <div class="input_label">{{ $t("common.product") }}</div>
                  <div v-if="transferData.products.length > 0" class="input_value">{{ getSelectedProduse() }}</div>
                  <div v-else class="input_value_placeholder" style="color: #989696 !important">{{ $t("stock_mobile.form.select_products") }}</div>
                  <div class="transfer_input_second_value">
                    {{ transferData.products.length > 2 ? $t("stock_mobile.form.more_products_count", { count: transferData.products.length - 2 }) : "" }}
                  </div>
                </div>
                <div class="transfer_parcel_edit_icon" @click="showProductSelector">
                  <i class="fa-regular fa-edit"></i>
                </div>
              </div>
            </div>
            <div class="transfer_input_holder">
              <div class="input_label">{{ $t("common.notes") }}</div>
              <div class="input_value">
                <DxTextArea v-model="transferData.notes" class="global_dx_number_input" :height="45" />
              </div>
            </div>
            <div class="transfer_input_holder">
              <Toggle
                :toggle-text="$t('stock_mobile.form.generate_delivery_note')"
                :toggledText="$t('common.yes')"
                :notToggledText="$t('common.no')"
                :is-active="transferData.generate_delivery_note"
                :on-change="onGenerateDeliveryNoteChange"
              />
            </div>
            <div v-show="transferData.generate_delivery_note">
              <div
                class="transfer_input_holder"
                :class="[{ input_holder_error: $v.transferData.delivery_data.driver_name.$error }]"
              >
                <div class="input_label">{{ $t("stock_mobile.form.delivery_driver_name") }}</div>
                <div class="input_value">
                  <DxTextBox v-model="transferData.delivery_data.driver_name" class="global_dx_textbox" />
                </div>
              </div>
              <div class="row-flex">
                <div
                  class="transfer_input_holder input_serie"
                  :class="[{ input_holder_error: $v.transferData.delivery_data.driver_serial_identifier.$error }]"
                >
                  <div class="input_label">{{ $t("stock_mobile.form.delivery_driver_serial") }}</div>
                  <div class="input_value">
                    <DxTextBox v-model="transferData.delivery_data.driver_serial_identifier" class="global_dx_textbox" />
                  </div>
                </div>
                <div
                  class="transfer_input_holder input_number"
                  :class="[{ input_holder_error: $v.transferData.delivery_data.driver_number_identifier.$error }]"
                >
                  <div class="input_label">{{ $t("stock_mobile.form.delivery_driver_number") }}</div>
                  <div class="input_value">
                    <DxTextBox v-model="transferData.delivery_data.driver_number_identifier" class="global_dx_textbox" />
                  </div>
                </div>
              </div>
              <div
                class="transfer_input_holder"
                :class="[{ input_holder_error: $v.transferData.delivery_data.vehicle_number_plate.$error }]"
              >
                <div class="input_label">{{ $t("stock_mobile.form.delivery_vehicle_plate") }}</div>
                <div class="input_value">
                  <DxTextBox v-model="transferData.delivery_data.vehicle_number_plate" class="global_dx_textbox" />
                </div>
              </div>
              <div
                class="transfer_input_holder"
                :class="[{ input_holder_error: $v.transferData.delivery_data.uploading_place.$error }]"
              >
                <div class="input_label">{{ $t("stock_mobile.form.delivery_uploading_place") }}</div>
                <div class="input_value">
                  <DxTextBox v-model="transferData.delivery_data.uploading_place" class="global_dx_textbox" />
                </div>
              </div>
              <div
                class="transfer_input_holder"
                :class="[{ input_holder_error: $v.transferData.delivery_data.unloading_place.$error }]"
              >
                <div class="input_label">{{ $t("stock_mobile.form.delivery_unloading_place") }}</div>
                <div class="input_value">
                  <DxTextBox v-model="transferData.delivery_data.unloading_place" class="global_dx_textbox" />
                </div>
              </div>
            </div>
            <div class="input-bottom-spacer"></div>
          </DxScrollView>
          <div v-show="step == 2" class="transfer_step_map">
            <OrdersSelectorMobile
              v-if="step == 2"
              :multiselect="true"
              :selectedOrders.sync="selectedOrders"
              :filterData="ordersFilterData"
              :toastMessageRef="$refs.toastMessageTransfer"
            />
          </div>
          <div class="transfer_bottom_sticky_two_line" v-show="step == 1 && showSaveButtons && productsDataValid && !saveButtonPressed">
            <div class="sticky_action_button" @click="saveTransfer(true)">{{ $t("stock_mobile.form.save_and_new_transfer") }}</div>
            <div class="sticky_action_button_second" @click="saveTransfer(false)">{{ $t("common.save") }}</div>
          </div>
          <div class="transfer_bottom_sticky" v-show="step == 2 && selectedOrders.length > 0">
            <div class="sticky_action_button" @click="continueFromOrdersSelection">{{ $t("common.continue") }}</div>
          </div>
          <div class="transfer_bottom_sticky" v-show="step == 1 && canOpenProductSelector && !productsDataValid">
            <div class="sticky_action_button" @click="showProductSelector">{{ $t("common.continue") }}</div>
          </div>
          <ProductSelectorMultiManager
            ref="productSelector"
            :showPopup="productSelectorVisibility"
            @hidden="hideProductSelector"
            @input="applyProductsSelection"
            :selectedProducts="transferData.products"
            :selectFromStock="true"
            :allowAddNew="false"
            :filterData="filterData"
            :movementDate="transferData.transfer_date"
            :transactionType="transactionTypeTitle"
            :sourceWarehouseName="sourceWarehouseName"
            :destWarehouseName="destWarehouseName"
            :ordersLabel="selectedOrdersLabel"
          >
          </ProductSelectorMultiManager>
        </div>
      </template>
    </DxTabPanel>
    <toast-message ref="toastMessageTransfer"></toast-message>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DxTabPanel from "devextreme-vue/tab-panel";
import { required, requiredIf, helpers } from "vuelidate/src/validators";
import { DxScrollView } from "devextreme-vue/scroll-view";
import ToastMessage from "@/components/Mobile/toastMessage.vue";
import DxSelectBox from "devextreme-vue/select-box";
import DxTextArea from "devextreme-vue/text-area";
import DxTextBox from "devextreme-vue/text-box";
import Toggle from "@/components/Toggle.vue";
import { FunctionalCalendar } from "vue-functional-calendar";
import moment from "moment";
import ProductSelectorMultiManager from "../Product/ProductSelectorMultiManager.vue";
import OrdersSelectorMobile from "@/components/Mobile/OrdersSelectorMobile.vue";
import { TransactionActions, TransactionOptions } from "../transactions.js";

const requiredByParamNumber = (value) => {
  return helpers.req(value) && value > 0;
};

export default {
  name: "Transfer",
  data() {
    return {
      preselectDate: true,
      calendarData: {},
      tabPanelAttributes: {
        class: "transfer_tabs",
      },
      transferSteps: [1, 2],
      currentStep: 0,
      currentItem: 1,
      transferData: {
        products: [],
        transfer_date: null,
        warehouse_uuid: null,
        dest_warehouse_uuid: null,
        notes: "",
        generate_delivery_note: false,
        delivery_data: {
          driver_name: "",
          driver_serial_identifier: "",
          driver_number_identifier: "",
          vehicle_number_plate: "",
          uploading_place: "",
          unloading_place: "",
        },
      },
      selectedOrders: [],
      warehouses: [],
      destWarehouses: [],
      is_date_selector_visible: false,
      allow_stock_movement_only_in_legal_entity: false,
      filterData: {},
      ordersFilterData: {},
      productSelectorVisibility: false,
      saveButtonPressed: false,
    };
  },
  components: {
    DxTabPanel,
    DxScrollView,
    ToastMessage,
    DxSelectBox,
    DxTextArea,
    DxTextBox,
    Toggle,
    FunctionalCalendar,
    ProductSelectorMultiManager,
    OrdersSelectorMobile,
  },
  computed: {
    ...mapGetters({
      getDefaultDateFormat: "settings/getDefaultDateFormat",
    }),
    canOpenProductSelector() {
      return !!(this.transferData.transfer_date && this.transferData.warehouse_uuid && this.transferData.dest_warehouse_uuid);
    },
    sourceWarehouseName() {
      const warehouse = this.warehouses.find((w) => w.uuid === this.transferData.warehouse_uuid);
      return warehouse?.name || "";
    },
    destWarehouseName() {
      const warehouse = this.destWarehouses.find((w) => w.uuid === this.transferData.dest_warehouse_uuid);
      return warehouse?.name || "";
    },
    selectedOrdersLabel() {
      if (!this.selectedOrders || this.selectedOrders.length === 0) {
        return "";
      }
      const uniqueNumbers = [...new Set(this.selectedOrders.map((c) => c.order_number))];
      return uniqueNumbers.join(", ");
    },
    transactionTypeTitle() {
      return TransactionOptions.find((opt) => opt.code === TransactionActions.Transfer)?.title || "";
    },
    showSaveButtons() {
      return (
        this.transferData.products.length > 0 &&
        !!(this.transferData.transfer_date && this.transferData.warehouse_uuid && this.transferData.dest_warehouse_uuid)
      );
    },
    productsDataValid() {
      if (!Array.isArray(this.transferData.products) || this.transferData.products.length === 0) {
        return false;
      }

      return this.transferData.products.every((product) => {
        const qty = parseFloat(product?.quantity) || 0;
        const max = parseFloat(product?.warehouse_quantity);
        if (qty <= 0) {
          return false;
        }
        if (Number.isFinite(max) && qty > max) {
          return false;
        }

        if (!product?.lot_management) {
          return true;
        }

        const items = Array.isArray(product.lot_items) ? product.lot_items : [];
        if (items.length === 0) {
          return false;
        }

        const sum = items.reduce((acc, item) => acc + (parseFloat(item.quantity) || 0), 0);
        if (sum <= 0 || Math.abs(sum - qty) > 0.0001) {
          return false;
        }

        return items.every((item) => (parseFloat(item.quantity) || 0) > 0);
      });
    },
    originalWarehouses() {
      return this.$store.getters["smWarehouses/smWarehouses"];
    },
  },
  validations() {
    const deliveryFieldRequired = requiredIf(() => this.transferData.generate_delivery_note);
    return {
      transferData: {
        products: {
          required,
          $each: {
            uuid: { required },
            quantity: { requiredByParamNumber },
          },
        },
        warehouse_uuid: { required },
        dest_warehouse_uuid: { required },
        transfer_date: { required },
        delivery_data: {
          driver_name: { required: deliveryFieldRequired },
          driver_serial_identifier: { required: deliveryFieldRequired },
          driver_number_identifier: { required: deliveryFieldRequired },
          vehicle_number_plate: { required: deliveryFieldRequired },
          uploading_place: { required: deliveryFieldRequired },
          unloading_place: { required: deliveryFieldRequired },
        },
      },
    };
  },
  methods: {
    warehouseDisplayExpr(item) {
      if (!item) return '';
      return item.department?.name ? `${item.name} (${item.department.name})` : item.name;
    },
    ...mapActions({
      getWarehouses: "smWarehouses/getSmWarehouses",
      createTransfer: "smTransactions/createTransferTransaction",
      getGroupByCode: "settings/getGroupByCode",
      getSmProductsFull: "smProducts/getSmProductsFull",
    }),
    tabSelectionChanged(e) {
      this.currentItem = e.addedItems[0];
      this.currentStep = this.transferSteps.indexOf(this.currentItem);
      this.changeAddButtonVisibility();
    },
    changeAddButtonVisibility() {
      this.$emit("changeAddButtonVisibility", false /*this.currentStep == 1*/);
    },
    goForward() {
      this.currentStep = this.currentStep + 1;
      this.setTitle();
    },
    getCurrentStep() {
      return this.currentStep;
    },
    setTitle() {
      if (this.currentStep == 0) {
        this.$emit("setTitle", this.$t("stock_mobile.form.product_transfer"), true);
      } else if (this.currentStep == 1) {
        this.$emit("setTitle", this.$t("stock_mobile.form.orders"), true);
      }
    },
    goBack() {
      if (this.currentStep > 0) {
        this.currentStep = this.currentStep - 1;
        this.setTitle();
      } else {
        this.$emit("goBackParent");
      }
    },
    ordersClick() {
      if (!this.transferData.warehouse_uuid) {
        this.$refs.toastMessageTransfer.showError(this.$t("stock_mobile.form.error_select_sender_warehouse_before_orders"));
        return;
      }
      this.currentStep = 1;
      this.setTitle();
    },
    async continueFromOrdersSelection() {
      if (!this.selectedOrders.length) {
        return;
      }

      const selectedLegalEntityUuid = this.selectedOrders[0]?.legal_entity_uuid ?? null;
      const missingStockItems = [];

      if (this.allow_stock_movement_only_in_legal_entity && selectedLegalEntityUuid) {
        const allSameLegalEntity = this.selectedOrders.every((o) => o.legal_entity_uuid === selectedLegalEntityUuid);
        if (!allSameLegalEntity) {
          this.$refs.toastMessageTransfer.showError(this.$t("stock_mobile.form.error_orders_same_legal_entity"));
          return;
        }
        this.$set(this.filterData, "department_legal_entity_uuid", selectedLegalEntityUuid);
      }

      let stockMap = {};
      const selectedProductUuids = [...new Set(this.selectedOrders.map((order) => order.product_uuid).filter(Boolean))];
      if (selectedProductUuids.length > 0) {
        try {
          const response = await this.getSmProductsFull({
            limit: selectedProductUuids.length,
            has_stock: 1,
            product_uuids: selectedProductUuids,
            department_legal_entity_uuid: selectedLegalEntityUuid ?? null,
          });
          const products = response?.data?.data || [];
          stockMap = products.reduce((acc, item) => {
            acc[item.uuid] = item;
            return acc;
          }, {});
        } catch (e) {
          stockMap = {};
        }
      }

      this.selectedOrders.forEach((order) => {
        const productUuid = order.product_uuid;
        if (!productUuid || this.transferData.products.some((p) => p.uuid === productUuid)) {
          return;
        }
        const productInfo = stockMap[productUuid] || {};
        const measureUnit = productInfo.measure_unit || (order.measure_unit ? { symbol: order.measure_unit } : null);
        const quantity = order.remaining_quantity ?? order.ordered_quantity ?? 0;
        const stockList = Array.isArray(productInfo.stock_list) ? productInfo.stock_list : [];
        const matchedWarehouse = stockList.find((stock) => stock.warehouse_uuid === this.transferData.warehouse_uuid) || null;
        if (!matchedWarehouse) {
          const orderNumber = order.order_number || "-";
          const productName = order.product_name || productInfo.name || "-";
          missingStockItems.push(this.$t("stock_mobile.form.order_product_line", { order: orderNumber, product: productName }));
          return;
        }
        const def_warehouse_uuid = matchedWarehouse.warehouse_uuid ?? null;
        const def_warehouse_name = matchedWarehouse.warehouse_name ?? null;
        const def_warehouse_quantity = matchedWarehouse.quantity ?? null;
        const def_warehouse_legal_entity_uuid = matchedWarehouse.legal_entity_uuid ?? null;

        this.transferData.products.push({
          uuid: productUuid,
          name: order.product_name || productInfo.name || "",
          quantity: quantity,
          measure_unit: measureUnit,
          measure_unit_id: productInfo.measure_unit?.id ?? null,
          product_type: productInfo.product_type ?? null,
          product_type_uuid: productInfo.product_type?.uuid ?? null,
          stock_list: productInfo.stock_list || [],
          lot_management: productInfo.lot_management ?? false,
          lot_items: [],
          warehouse_uuid: def_warehouse_uuid,
          warehouse_name: def_warehouse_name,
          warehouse_quantity: def_warehouse_quantity,
          warehouse_department_legal_entity_uuid: def_warehouse_legal_entity_uuid,
          dest_warehouse_uuid: null,
          dest_warehouse_name: null,
          order_uuid: order.uuid || null,
        });
      });

      this.currentStep = 0;
      this.setTitle();

      if (missingStockItems.length > 0) {
        this.$refs.toastMessageTransfer.showInfo([this.$t("stock_mobile.form.info_products_no_stock_in_selected_warehouse"), ...missingStockItems]);
      }
    },
    saveTransfer(saveAndNew) {
      this.saveButtonPressed = true;
      this.$v.transferData.$touch();
      if (!this.$v.transferData.$invalid) {
        const overWarehouseQty = this.transferData.products.some((product) => {
          const qty = parseFloat(product?.quantity) || 0;
          const max = parseFloat(product?.warehouse_quantity);
          return Number.isFinite(max) && qty > max;
        });

        if (overWarehouseQty) {
          this.saveButtonPressed = false;
          this.$refs.toastMessageTransfer.showError(this.$t("stock_mobile.form.error_quantity_exceeds_stock"));
          return;
        }

        const lotSumInvalid = this.transferData.products.some((product) => {
          if (!product?.lot_management) {
            return false;
          }
          const items = Array.isArray(product.lot_items) ? product.lot_items : [];
          const sum = items.reduce((acc, item) => acc + (parseFloat(item.quantity) || 0), 0);
          const qty = parseFloat(product.quantity) || 0;
          return Math.abs(sum - qty) > 0.0001 || qty <= 0 || items.some((item) => (parseFloat(item.quantity) || 0) <= 0) || sum <= 0;
        });

        if (lotSumInvalid) {
          this.saveButtonPressed = false;
          this.$refs.toastMessageTransfer.showError(this.$t("stock_mobile.form.error_lot_sum_must_match"));
          return;
        }

        if (this.allow_stock_movement_only_in_legal_entity) {
          const invalidLegalEntity = this.transferData.products.some((product) => {
            const sourceLegalEntity = this.getWarehouseLegalEntityByUuid(this.transferData.warehouse_uuid);
            const destLegalEntity = this.getWarehouseLegalEntityByUuid(this.transferData.dest_warehouse_uuid);
            return sourceLegalEntity && destLegalEntity && sourceLegalEntity !== destLegalEntity;
          });

          if (invalidLegalEntity) {
            this.saveButtonPressed = false;
            this.$refs.toastMessageTransfer.showError(this.$t("stock_mobile.form.error_receiver_warehouse_legal_entity_mismatch"));
            return;
          }
        }

        let transferDataForSave = {
          products: this.transferData.products.map((product) => ({
            uuid: product.uuid,
            quantity: product.quantity,
            lot_items: Array.isArray(product.lot_items) ? product.lot_items : [],
            order_uuid: product.order_uuid,
          })),
          notes: this.transferData.notes,
          warehouse_uuid: this.transferData.warehouse_uuid,
          dest_warehouse_uuid: this.transferData.dest_warehouse_uuid,
          transfer_date: this.transferData.transfer_date,
          generate_delivery_note: this.transferData.generate_delivery_note ? 1 : 0,
        };

        if (this.transferData.generate_delivery_note) {
          transferDataForSave.delivery_data = { ...this.transferData.delivery_data };
        }

        this.createTransfer(transferDataForSave)
          .then((response) => {
            this.$refs.toastMessageTransfer.showSuccess(this.$t("stock_mobile.form.transfer_saved"));
            if (saveAndNew) {
              this.resetForm();
              this.saveButtonPressed = false;
            } else {
              this.closeTransactions(this.$t("stock_mobile.form.transfer_saved"));
            }
          })
          .catch((e) => {
            this.saveButtonPressed = false;
            const status = e?.response?.status;
            const backendMessage = e?.response?.data?.errors?.error || e?.response?.data?.message;

            if ((status === 400 || status === 500) && backendMessage) {
              this.$refs.toastMessageTransfer.showError(backendMessage);
            } else {
              this.$refs.toastMessageTransfer.showError(this.$t("stock_mobile.form.error_transfer_save_failed"));
            }
          });
      } else {
        this.saveButtonPressed = false;
        this.$refs.toastMessageTransfer.showError(this.createErrorMessages());
      }
    },
    getSettings() {
      this.getGroupByCode({
        code: "STOCK_MANAGEMENT",
      }).then((response) => {
        let _setting_le = response.items.find((obj) => obj.code == "ALLOW_STOCK_MOVEMENT_ONLY_IN_LEGAL_ENTITY");
        this.allow_stock_movement_only_in_legal_entity = false;
        if (_setting_le !== undefined) {
          this.allow_stock_movement_only_in_legal_entity = _setting_le.value == "1";
        }

        let _preselectSetting = response.items.find((obj) => obj.code == "USE_CURRENT_DATE_ON_CREATION");
        this.preselectDate = _preselectSetting?.value == "1";
        if (this.preselectDate) {
          this.transferData.transfer_date = moment().format(this.getDefaultDateFormat);
        }
      });
    },
    resetForm() {
      this.$v.$reset();
      this.transferData = {
        products: [],
        transfer_date: this.preselectDate ? moment().format(this.getDefaultDateFormat) : null,
        warehouse_uuid: null,
        dest_warehouse_uuid: null,
        notes: "",
        generate_delivery_note: false,
        delivery_data: {
          driver_name: "",
          driver_serial_identifier: "",
          driver_number_identifier: "",
          vehicle_number_plate: "",
          uploading_place: "",
          unloading_place: "",
        },
      };
      this.selectedOrders = [];
      this.ordersFilterData = {};
      this.filterData = {};
    },
    onGenerateDeliveryNoteChange(value) {
      this.transferData.generate_delivery_note = value;
      if (!value) {
        this.$v.transferData.delivery_data.$reset();
      }
    },
    closeTransactions(message) {
      this.$emit("closeTransactions", message);
    },
    getSelectedProduse() {
      if (this.transferData.products.length > 0) {
        if (this.transferData.products.length === 1) {
          return this.transferData.products[0].name;
        } else if (this.transferData.products.length > 1) {
          return this.transferData.products[0].name + ", " + this.transferData.products[1].name;
        }
      } else {
        return this.$t("stock_mobile.form.select_product");
      }
    },
    getSelectedOrders() {
      if (this.selectedOrders && this.selectedOrders.length > 0) {
        const uniqueNumbers = [...new Set(this.selectedOrders.map((c) => c.order_number))];
        return uniqueNumbers.join(", ");
      }
      return this.$t("stock_mobile.form.select_orders");
    },
    getWarehouseLegalEntityByUuid(warehouseUuid) {
      const warehouse =
        this.originalWarehouses.find((w) => w.uuid === warehouseUuid) || this.warehouses.find((w) => w.uuid === warehouseUuid);
      return warehouse?.legal_entity_uuid ?? null;
    },
    createErrorMessages() {
      let errorMessages = [];

      if (this.$v.transferData.transfer_date.$invalid) {
        errorMessages.push(this.$t("stock_mobile.form.error_transfer_date_required"));
      }

      if (this.transferData.products.length <= 0) {
        errorMessages.push(this.$t("stock_mobile.form.error_product_required"));
      }

      if (this.transferData.generate_delivery_note && this.$v.transferData.delivery_data.$invalid) {
        errorMessages.push(this.$t("stock_mobile.form.error_delivery_data_required"));
      }

      this.transferData.products.forEach((product) => {
        if (!this.transferData.warehouse_uuid) {
          errorMessages.push(this.$t("stock_mobile.form.error_sender_warehouse_required", { name: product.name }));
        }
        if (!this.transferData.dest_warehouse_uuid) {
          errorMessages.push(this.$t("stock_mobile.form.error_receiver_warehouse_required", { name: product.name }));
        }
        if (!product.quantity || product.quantity <= 0) {
          errorMessages.push(this.$t("stock_mobile.form.error_quantity_gt_zero_for", { name: product.name }));
        }

        const max = parseFloat(product?.warehouse_quantity);
        const qty = parseFloat(product?.quantity) || 0;
        if (Number.isFinite(max) && qty > max) {
          errorMessages.push(this.$t("stock_mobile.form.error_quantity_exceeds_stock_for", { name: product.name }));
        }

        if (this.allow_stock_movement_only_in_legal_entity) {
          const sourceLegalEntity = this.getWarehouseLegalEntityByUuid(this.transferData.warehouse_uuid);
          const destLegalEntity = this.getWarehouseLegalEntityByUuid(this.transferData.dest_warehouse_uuid);
          if (sourceLegalEntity && destLegalEntity && sourceLegalEntity !== destLegalEntity) {
            errorMessages.push(this.$t("stock_mobile.form.error_receiver_warehouse_legal_entity_mismatch_for", { name: product.name }));
          }
        }
      });

      return errorMessages;
    },
    warehouseChanged(e) {
      if (e.selectedItem) {
        this.availableQuantity = e.selectedItem.quantity;
        this.selectedOrders = [];
        this.transferData.products = [];
        const currentWhs = this.originalWarehouses.find((w) => w.uuid === e.selectedItem.uuid);

        this.destWarehouses.forEach((w) => {
          w.is_source = w.uuid == e.selectedItem.uuid;
        });

        //filter only in the same legal entity
        this.destWarehouses = this.originalWarehouses.filter((dwhs) => {
          if (this.allow_stock_movement_only_in_legal_entity) {
            return currentWhs && dwhs.legal_entity_uuid === currentWhs.legal_entity_uuid && dwhs.uuid !== e.selectedItem.uuid;
          }

          return dwhs;
        });

        this.$set(this.filterData, "warehouse_uuid", e.selectedItem.uuid);
      }
    },
    getWarehouseDepartmentByWarehouseUuid(warehouseUuid) {
      let warehouse = this.warehouses.find((w) => w.uuid == warehouseUuid);
      if (warehouse) {
        return warehouse.department_uuid;
      }
      return null;
    },
    showCalendarSelector() {
      this.is_date_selector_visible = !this.is_date_selector_visible;
    },
    calendarDayChosen(data) {
      this.is_date_selector_visible = false;
    },
    onDateSelected(date) {
      this.transferData.transfer_date = date.selectedDate;
    },
    showProductSelector() {
      if (!this.transferData.warehouse_uuid) {
        this.$refs.toastMessageTransfer.showError(this.$t("stock_mobile.form.error_select_sender_warehouse_before_products"));
        return;
      }
      if (!this.transferData.transfer_date) {
        this.$refs.toastMessageTransfer.showError(this.$t("stock_mobile.form.error_transfer_date_select_required"));
        return;
      }
      this.productSelectorVisibility = true;
    },
    hideProductSelector() {
      this.productSelectorVisibility = false;
    },
    applyProductsSelection(products) {
      this.transferData.products = Array.isArray(products) ? products : [];
    },
  },
  mounted() {
    this.getSettings();
    this.setTitle();
    this.getWarehouses({
      enablePagination: 0,
      limit: 1000,
      filter: [["is_active", "=", 1]],
    }).then((response) => {
      this.warehouses = response.data;
      this.destWarehouses = response.data;
    });
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/stockMobile/transfer.scss";

.transfer_tabs {
  .row-flex {
    display: flex;
    gap: 12px;

    .input_serie {
      width: 40%;
    }

    .input_number {
      width: 60%;
    }
  }
}
</style>
